import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=53ec1ab2&scoped=true&"
import script from "./Bill.vue?vue&type=script&lang=ts&"
export * from "./Bill.vue?vue&type=script&lang=ts&"
import style0 from "./Bill.vue?vue&type=style&index=0&id=53ec1ab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec1ab2",
  null
  
)

export default component.exports